import { fromTable } from '@/integrations/supabase/db';
import { SearchResult, SearchSectionId } from '../types';
import { getMatchFunction, getServerPattern, getServerLimit, calculateRelevanceScore } from '../utils';

export async function searchAbrechnungen(
  term: string, 
  limit: number, 
  exactMatch: boolean,
  fuzzyMatch: boolean = false,
  signal?: AbortSignal
): Promise<SearchResult[]> {
  if (!term.trim()) return [];
  
  const pattern = getServerPattern(term, fuzzyMatch);
  const serverLimit = getServerLimit(limit, fuzzyMatch);
  const matchFn = getMatchFunction(exactMatch, fuzzyMatch);
  
  const { data, error } = await fromTable('abrechnungen')
    .select('id, titel, abrechnungsbetrag, datum, abrechnungsnummer, updated_at')
    .or(`titel.ilike.${pattern}`)
    .limit(serverLimit);

  if (error) {
    console.error('Abrechnungen search error:', error);
    return [];
  }

  return (data || [])
    .filter(a => matchFn(term, a.titel, String(a.abrechnungsnummer)))
    .slice(0, limit)
    .map(a => {
      const title = a.titel || `Abrechnung ${a.abrechnungsnummer || ''}`;
      const subtitle = a.abrechnungsbetrag ? `€ ${a.abrechnungsbetrag.toLocaleString('de-DE')}` : undefined;
      
      return {
        id: a.id,
        type: 'abrechnungen' as SearchSectionId,
        title,
        subtitle,
        badge: 'Abrechnung',
        data: a,
        relevanceScore: calculateRelevanceScore(term, title, subtitle, a.updated_at)
      };
    });
}
